"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = Book;

var _Book = require("@adobe/react-spectrum-workflow/dist/Book");

var _icon = require("@react-spectrum/icon");

var _react = _interopRequireDefault(require("react"));

function Book(props) {
  return /*#__PURE__*/_react.default.createElement(_icon.Icon, props, /*#__PURE__*/_react.default.createElement(_Book.A4uBook, null));
}